var map = {
	"./bg-left.png": "04a6",
	"./bg-right.png": "f679",
	"./intro-screen.png": "18a2",
	"./logo.png": "cf05",
	"./product-bisacodyl.png": "c03c",
	"./product-liquidglycerin.png": "ed63",
	"./product-mineral.png": "40fc",
	"./product-saline.png": "33c6",
	"./product-salineextra.png": "b9ad",
	"./product-suppositories.png": "e162",
	"./your-relief-solution.png": "01ca"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";